import { Formik } from 'formik'
import React from 'react'
import { Button, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { ReactComponent as Small_Arrow } from "../../../../../../assets/utils/images/svgs/Small_Arrow.svg"
import { ReactComponent as Save } from "../../../../../../assets/utils/images/svgs/save_two.svg";
const DagdeelMemo = ({ showMemoModal, setShowMemoModal, opmerkingValue, setOpmerkingValue, handleMemoSubmit }) => {
    return (
        <Modal id={"tooltip"} isOpen={showMemoModal} toggle={() => setShowMemoModal(!showMemoModal)} className="verzoeken-memo-modal modal-dialog__over feedback-modal-style opmerking-modal-styling vervanger-memo-modal ">
            <ModalHeader>
                <div className="modal-header-styling">
                    Memo t.b.v. dagdeel
                </div>
                <div className="cross-icon-color">
                    <i className="nav-link-icon lnr-cross m-1 cursor-pointer" onClick={() => setShowMemoModal(false)}> </i>
                </div>
            </ModalHeader>

            <ModalBody className="bg-white rounded">
                <Formik
                    enableReinitialize
                    initialValues={{ message: opmerkingValue || '' }}
                    onSubmit={(values, { setSubmitting }) => handleMemoSubmit(values, setSubmitting)}
                >
                    {({
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        values
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Input
                                type="textarea"
                                className="form-style opmerking-input-styling mt-3"
                                name='message'
                                onChange={(e) => {
                                    setOpmerkingValue(e.target.value || "")
                                }}
                                onBlur={handleBlur}
                                value={values.message}
                                rows="6"
                            />
                            <ModalFooter>
                                <Button className="d-flex align-items-center btn-color-style  opslaan-btn" size="sm" outline color="primary" type="submit" disabled={isSubmitting}>
                                    <Save />
                                    Opslaan
                                </Button>
                                <Button className="d-flex align-items-center btn-color-style back-btn" size="sm" outline color="primary" onClick={() => setShowMemoModal(false)}>
                                    <Small_Arrow />
                                    Terug
                                </Button>
                            </ModalFooter>
                        </Form>
                    )}
                </Formik>
            </ModalBody>

        </Modal>
    )
}

export default DagdeelMemo
